module.exports = __webpack_public_path__ + "media/svg/google-play-675cbf2b.svg";